<template>
    <tr class="tr clickable" v-if="showRow">
        <td class="td mobile_whitespace-normal mobile_text-center">
            <img :src="rowData.image" class="valign-middle w-20px mr-10px mobile_mr-0"/>
            {{ rowData.asset.toUpperCase() }}
        </td>

        <td class="td" v-for="columnWithSettings in visibleColumnsWithSettings" :key="columnWithSettings.column" :class="getColumnClass(columnWithSettings)">
            {{ getColumnPrefix(columnWithSettings) }}{{ getColumnValue(columnWithSettings.column, columnWithSettings.settings) }}{{ getColumnSuffix(columnWithSettings) }}
        </td>
    </tr>
</template>

<script>
import portfolioColumns from '@/services/portfolioColumns'

export default {
    props:{
        rowData: Object,
    },
    computed:{
        visibleColumnsWithSettings(){
            return portfolioColumns.visibleColumnsWithSettings
        },
        isCurrentlyHolding(){
            return this.rowData.currentWorth > 0
        },
        showRow(){
            if(!this.isCurrentlyHolding && !portfolioColumns.showSoldItems){
                return false
            }
            return true
        }
    },
    methods:{
        getColumnValue(column, colSettings){
            if(!this.isCurrentlyHolding && colSettings.hideWhenSold){
                return ''
            }
            if(colSettings.decimals != undefined){
                return this.rowData[column].toFixed(colSettings.decimals)
            }
            return this.rowData[column]
        },
        getColumnPrefix(columnWithSettings){
            if(!this.isCurrentlyHolding && columnWithSettings.settings.hideWhenSold){
                return ''
            }
            return columnWithSettings.settings.prefix || ''
        },
        getColumnSuffix(columnWithSettings){
            if(!this.isCurrentlyHolding && columnWithSettings.settings.hideWhenSold){
                return ''
            }
            return columnWithSettings.settings.suffix || ''
        },
        getColumnClass(columnWithSettings){
            if(!this.isCurrentlyHolding && columnWithSettings.settings.hideWhenSold){
                return ''
            }
            if(!columnWithSettings.settings.class){
                return ''
            }
            const value = this.getColumnValue(columnWithSettings.column, columnWithSettings.settings)
            return columnWithSettings.settings.class(value)
        }
    },
}
</script>